<script lang="ts">
  import Button from '$components/ui/button.svelte';
  import { cn } from '$lib/utils';
  import { getAnchorFromCmsLink } from '$lib/utils/cms';
  import type { ContactStoryblok } from '$types/bloks';

  export let block: ContactStoryblok;

  let className: string | undefined = undefined;
  export { className as class };
</script>

{#if block.title || block.text}
  <div
    class={cn(
      'p-3 bg-primary/2 border border-primary/4 rounded-md flex flex-col justify-between items-start',
      className
    )}
  >
    <div class="flex flex-col gap-0.5">
      {#if block.title}
        <p class="text-md font-semibold">{block.title}</p>
      {/if}
      {#if block.text}
        <p class="text-md">{block.text}</p>
      {/if}
    </div>
    {#if block.cta}
      {@const cta = block.cta[0]}
      {#if cta.link}
        {@const { href, rel, target } = $getAnchorFromCmsLink(cta.link)}
        <Button
          name={cta.label || 'cta'}
          as="a"
          size="sm"
          {href}
          {rel}
          {target}
          block={cta}
          class="mt-8"
          variant={cta.variant}>{cta.label}</Button
        >
      {/if}
    {/if}
  </div>
{/if}
